export const SUBMIT_FEEDBACK = "SUBMIT_FEEDBACK";
export const SUBMIT_FEEDBACK_SUCCESSFUL = "SUBMIT_FEEDBACK_SUCCESSFUL";
export const SUBMIT_FEEDBACK_FAILED = "SUBMIT_FEEDBACK_FAILED";

//Interviwer feedback

export const VERIFY_CODE = "VERIFY_CODE";
export const VERIFY_CODE_SUCCESSFUL = "VERIFY_CODE_SUCCESSFUL";
export const VERIFY_CODE_FAILED = "VERIFY_CODE_FAILED";
export const INTERVIEW_FEEDBACK = "INTERVIEW_FEEDBACK";
export const INTERVIEW_FEEDBACK_SUCCESSFUL = "INTERVIEW_FEEDBACK_SUCCESSFUL";
export const INTERVIEW_FEEDBACK_FAILED = "INTERVIEW_FEEDBACK_FAILED";

//Shortlist feedback

export const VERIFY_CODE_SHORTLIST = "VERIFY_CODE_SHORTLIST";
export const VERIFY_CODE_SHORTLIST_SUCCESSFUL =
  "VERIFY_CODE_SHORTLIST_SUCCESSFUL";
export const VERIFY_CODE_SHORTLIST_FAILED = "VERIFY_CODE_SHORTLIST_FAILED";
export const SHORTLIST_FEEDBACK = "SHORTLIST_FEEDBACK";
export const SHORTLIST_FEEDBACK_SUCCESSFUL = "SHORTLIST_FEEDBACK_SUCCESSFUL";
export const SHORTLIST_FEEDBACK_FAILED = "SHORTLIST_FEEDBACK_FAILED";

//interviewer details
export const GET_INTERVIEWERS_LIST = "GET_INTERVIEWERS_LIST";
export const GET_INTERVIEWERS_LIST_SUCCESS = "GET_INTERVIEWERS_LIST_SUCCESS";
export const GET_INTERVIEWERS_LIST_FAIL = "GET_INTERVIEWERS_LIST_FAIL";

//interview questions
export const GET_INTERVIEW_QUESTION_LIST = "GET_INTERVIEW_QUESTION_LIST";
export const GET_INTERVIEW_QUESTION_LIST_SUCCESS =
  "GET_INTERVIEW_QUESTION_LIST_SUCCESS";
export const GET_INTERVIEW_QUESTION_LIST_FAIL =
  "GET_INTERVIEW_QUESTION_LIST_FAIL";

//interview questions based on interview id
export const GET_INTERVIEW_QUESTION_LIST_ID = "GET_INTERVIEW_QUESTION_LIST_ID";
export const GET_INTERVIEW_QUESTION_LIST_ID_SUCCESS =
  "GET_INTERVIEW_QUESTION_LIST_ID_SUCCESS";
export const GET_INTERVIEW_QUESTION_LIST_ID_FAIL =
  "GET_INTERVIEW_QUESTION_LIST_ID_FAIL";

//interview questions REVIEW
export const GET_INTERVIEW_QUESTION_REVIEW_LIST =
  "GET_INTERVIEW_QUESTION_REVIEW_LIST";
export const GET_INTERVIEW_QUESTION_REVIEW_LIST_SUCCESS =
  "GET_INTERVIEW_QUESTION_REVIEW_LIST_SUCCESS";
export const GET_INTERVIEW_QUESTION_REVIEW_LIST_FAIL =
  "GET_INTERVIEW_QUESTION_REVIEW_LIST_FAIL";

//candidateDetails

export const GET_FEEDBACK_CANDIDATE_DATA = "GET_FEEDBACK_CANDIDATE_DATA";
export const GET_FEEDBACK_CANDIDATE_DATA_SUCCESS =
  "GET_FEEDBACK_CANDIDATE_DATA_SUCCESS";
export const GET_FEEDBACK_CANDIDATE_DATA_FAIL =
  "GET_FEEDBACK_CANDIDATE_DATA_FAIL";

//screening and shortlist
export const GET_SHORTLIST_DATA = "GET_SHORTLIST_DATA";
export const GET_SHORTLIST_DATA_SUCCESS = "GET_SHORTLIST_DATA_SUCCESS";
export const GET_SHORTLIST_DATA_FAIL = "GET_SHORTLIST_DATA_FAIL";

export const GET_SHORTLIST_FILTER_DATA = "GET_SHORTLIST_FILTER_DATA";

//candidate resume details

export const GET_CANDIDATE_RESUME_DETAILS = "GET_CANDIDATE_RESUME_DETAILS";
export const GET_CANDIDATE_RESUME_DETAILS_SUCCESS =
  "GET_CANDIDATE_RESUME_DETAILS_SUCCESS";
export const GET_CANDIDATE_RESUME_DETAILS_FAIL =
  " GET_CANDIDATE_RESUME_DETAILS_FAIL";

export const GET_SHORLISTING_CANDIDATES_LIST =
  "GET_SHORLISTING_CANDIDATES_LIST";
export const GET_SHORLISTING_CANDIDATES_LIST_SUCCESS =
  "GET_SHORLISTING_CANDIDATES_LIST_SUCCESS";
export const GET_SHORLISTING_CANDIDATES_LIST_FAIL =
  "GET_SHORLISTING_CANDIDATES_LIST_FAIL";

export const GET_SEARCH_SHORTLISTING_CANDIDATE =
  "GET_SEARCH_SHORTLISTING_CANDIDATE";

export const GET_CANDIDATES_MODAL_DATA = "GET_CANDIDATES_MODAL_DATA";
export const GET_CANDIDATES_MODAL_DATA_SUCCESS =
  "GET_CANDIDATES_MODAL_DATA_SUCCESS";
export const GET_CANDIDATES_MODAL_DATA_FAIL = "GET_CANDIDATES_MODAL_DATA_FAIL";

export const GET_OFFER_DATA = "GET_OFFER_DATA";
export const GET_OFFER_DATA_SUCCESS = "GET_OFFER_DATA_SUCCESS";
export const GET_OFFER_DATA_FAIL = "GET_OFFER_DATA_FAIL";

//offer page

export const POST_OFFER_DATA = "POST_OFFER_DATA";
export const POST_OFFER_DATA_SUCCESS = "POST_OFFER_DATA_SUCCESS";
export const POST_OFFER_DATA_FAIL = "POST_OFFER_DATA_FAIL";

//Hire similar candidate
export const GET_HIRE_CANDIDATE_LIST = "GET_HIRE_CANDIDATE_LIST";
export const GET_HIRE_CANDIDATE_LIST_SUCCESS =
  "GET_HIRE_CANDIDATE_LIST_SUCCESS";
export const GET_HIRE_CANDIDATE_LIST_FAIL = "GET_HIRE_CANDIDATE_LIST_FAIL";

export const SUBMIT_HIRING_FEEDBACK_DATA = "SUBMIT_HIRING_FEEDBACK_DATA";
export const SUBMIT_HIRING_FEEDBACK_DATA_SUCCESS =
  "SUBMIT_HIRING_FEEDBACK_DATA_SUCCESS";
export const SUBMIT_HIRING_FEEDBACK_DATA_FAIL =
  "SUBMIT_HIRING_FEEDBACK_DATA_FAIL";

export const GET_HIRE_SUBMIT_FEEDBACK_STATUS =
  "GET_HIRE_SUBMIT_FEEDBACK_STATUS";
export const GET_HIRE_SUBMIT_FEEDBACK_STATUS_SUCCESS =
  "GET_HIRE_SUBMIT_FEEDBACK_STATUS_SUCCESS";
export const GET_HIRE_SUBMIT_FEEDBACK_STATUS_FAIL =
  "GET_HIRE_SUBMIT_FEEDBACK_STATUS_FAIL";

//hiring feedback
export const GET_HIRING_INTERVIEWER_LIST = "GET_HIRING_INTERVIEWER_LIST";
export const GET_HIRING_INTERVIEWER_LIST_SUCCESS =
  "GET_HIRING_INTERVIEWER_LIST_SUCCESS";
export const GET_HIRING_INTERVIEWER_LIST_FAIL =
  "GET_HIRING_INTERVIEWER_LIST_FAIL";

//hiring feedback page candidate data

export const GET_HIRING_FEEDBACK_CANDIDATE_DATA =
  "GET_HIRING_FEEDBACK_CANDIDATE_DATA";

//hiring feedback page shortlist data
export const GET_HIRING_SHORTLIST_DATA = "GET_HIRING_SHORTLIST_DATA";

//hire feedback page resume details

export const GET_HIRE_CANDIDATE_RESUME_DETAILS =
  "GET_HIRE_CANDIDATE_RESUME_DETAILS";

//short list submit status
export const GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS =
  "GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS";

//interview submit status
export const GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS =
  "GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS";
